import React from "react";
import PropTypes from "prop-types";
import GenericCard from "components/UI/GenericCard/GenericCard";
import { returnUpDownClassname } from "utils/helpers";

const ExpectancyCard = (props) => {
  const { avgWinReturn, avgLossReturn, expectancy, profitFactor } =
    props.optionsResults.metrics.expectancy;

  return (
    <GenericCard
      title="Expectancy"
      tooltipText="Blended average realized return per signal: winners exit at their hit-bar close, misses are forced out at the window-end close. This is the underlying's average move per signal, not option P&L -- no premium/greeks modeled -- but it's the raw edge before options costs eat into it."
    >
      <div>
        <h2 className={returnUpDownClassname(expectancy)}>{expectancy}%</h2>
        <h5>avg realized return per signal</h5>
      </div>
      <div className="pt-2 flex gap-8">
        <div>
          <h5>Avg win</h5>
          <h3 className={returnUpDownClassname(avgWinReturn)}>
            {avgWinReturn}%
          </h3>
        </div>
        <div>
          <h5>Avg miss</h5>
          <h3 className={returnUpDownClassname(avgLossReturn)}>
            {avgLossReturn}%
          </h3>
        </div>
        <div>
          <h5>Profit factor</h5>
          <h3>{profitFactor === null ? "N/A" : profitFactor}</h3>
        </div>
      </div>
    </GenericCard>
  );
};

ExpectancyCard.propTypes = { optionsResults: PropTypes.object };

export default ExpectancyCard;
